import { useEffect } from "react";
import { useLanderConfig } from "../commons/ConfigContext";
import { sendErrorEvent } from "../commons/LanderEvent";
import { ErrorCode } from "../commons/Constants";
import { FeedType, LanderConfig } from "../types/LanderConfig";
import { getExpiryPartnerConfig } from "../commons/LanderConfig";

export const rsocRedirect = async (landerConfig: LanderConfig) => {
  try {
    let rsocUrl: URL;
    if (landerConfig.rsoc.url) {
      rsocUrl = new URL(landerConfig.rsoc.url);
    } else {
      rsocUrl = new URL(landerConfig.rsoc.path, "https://www.searchhounds.com");
    }

    // Query params that will be used in searchhounds
    rsocUrl.searchParams.set("psystem", landerConfig.system);
    rsocUrl.searchParams.set("domain", window.location.hostname);

    const expiryPortfolioId = getExpiryPartnerConfig().portfolioId || "";
    if (expiryPortfolioId) rsocUrl.searchParams.set("pid", expiryPortfolioId);

    // Preserve original referrer - check query param first, then document.referrer
    // The oref query parameter may be set by JS redirect from parking-lander-tls-terminator
    // https://github.com/gdcorp-domains/parking-lander-tls-terminator
    const urlParams = new URLSearchParams(window.location.search);
    const orefParam = urlParams.get("oref");
    const originalReferrer = orefParam || document.referrer;
    if (originalReferrer) {
      rsocUrl.searchParams.set("oref", originalReferrer);
    }

    location.assign(rsocUrl.toString());
  } catch (error) {
    sendErrorEvent(landerConfig, ErrorCode.ERROR_RSOC_REDIRECT);
  }
};

export function useRsoc() {
  const { landerConfig } = useLanderConfig();

  const rsocPathOrUrlExists =
    !!landerConfig.rsoc?.path || !!landerConfig.rsoc?.url;
  const feedIDIsRsoc = landerConfig.lander?.feedID === FeedType.RSOC;
  const domainIsCloudynestStore =
    landerConfig.domain?.rootDomain === "cloudynest.store"; // This domain was reported by Google for paid traffic. This is a temporary fix until we find a better way to detect paid traffic.

  const rsocRedirectEnabled =
    rsocPathOrUrlExists && feedIDIsRsoc && !domainIsCloudynestStore;

  useEffect(() => {
    if (rsocRedirectEnabled) rsocRedirect(landerConfig);
  }, [rsocRedirectEnabled, landerConfig]);

  return { rsocRedirectEnabled };
}
